import { Integration_Auth_Names_Enum, Integration_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationAuth, IntegrationConnector, IntegrationConnectorCategory } from '../../lib';

export type ServicenowConnectorConfig<
  T extends
    (typeof ServicenowConnector._.NamedConfig)['authName'] = (typeof ServicenowConnector._.NamedConfig)['authName'],
> = typeof ServicenowConnector._.NamedConfig & { authName: T };

export const ServicenowConnector = IntegrationConnector.make({
  provider: Integration_Names_Enum.Servicenow,
  logoPath: 'images/servicenow-logo.svg',
  categories: [IntegrationConnectorCategory.ITSM],
  auths: IntegrationAuth.group([
    IntegrationAuth.manual({
      name: Integration_Auth_Names_Enum.AppOauthClientCredentials,
      configSchema: z.object({
        baseUrl: z.url(),
        clientId: z.string().trim().min(1),
      }),
      encryptedConfigSchema: z.object({
        clientSecret: z.string().trim().min(1),
      }),
    }),
    IntegrationAuth.manual({
      deprecated: true,
      name: Integration_Auth_Names_Enum.ApiToken,
      configSchema: z.object({
        baseUrl: z.url(),
      }),
      encryptedConfigSchema: z.object({
        apiToken: z.string().trim().min(1),
      }),
    }),
  ]),
});
